import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSupplierSpecialPricingRulesReadQuery } from 'api';

export const useSpecialPricingRules = () => {
  const [addModalState, setAddModalState] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [dataToEdit, setDataToEdit] = useState<{ id: string | undefined }>({ id: undefined });

  const { id } = useParams() as { id: string };
  const { data: pricingRules = [] } = useSupplierSpecialPricingRulesReadQuery({ supplierId: id });

  const onAddModalStateChange = useCallback(() => setAddModalState((prevState) => !prevState), []);

  const onHandleDelete = useCallback((data: { id: string | undefined }) => {
    setDataToEdit(data);
    setIsDeleteModalOpen(true);
  }, []);
  const onDeleteModalClose = useCallback(() => {
    setIsDeleteModalOpen(false);
    setDataToEdit({ id: undefined });
  }, []);
  return {
    pricingRules,
    onAddModalStateChange,
    addModalState,
    onDeleteModalClose,
    onHandleDelete,
    isDeleteModalOpen,
    dataToEdit,
  };
};
